import React, {Fragment, useRef, useState} from "react";
import {Button, Col, Modal, Row} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import RestClient from "../../RestAPI/RestClient";
import AppUrl from "../../RestAPI/AppUrl";
import cogoToast from "cogo-toast";
import Loading from "../Loading/Loading";
import LoadingText from "../Loading/LoadingText";
import {useSelector} from "react-redux";
import appUtility from "../../RestAPI/AppUtility";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReactToPrint from "react-to-print";
import DatePicker from "react-datepicker";


export default function CallReport(){
    let state=useSelector((state)=> state);
    const ref=useRef();

    const [DivisionCall, setDivisionCall]=useState([]);
    const [CircleCall, setCircleCall]=useState([]);
    const [DataCall, setDataCall]=useState([]);
    const [ColumnCall, setColumnCall]=useState([{}]);
    const [DataLengthCall, setDatalengthCall]=useState(0);
    const[DataStatusCall, setDataStatusCall]=useState(false);
    const [CallDate, setCallDate] = useState(new Date());
    const [DataCallRecord, setDataCallRecord]=useState([]);
    const [ColumnCallRecord, setColumnCallRecord]=useState([{}]);

    const[BinCallRecord, setBinCallRecord]=useState()
    const[NameCallRecord, setNameCallRecord]=useState()

    const [showCallRecord, setShowCallRecord] = useState(false);
    const handleCloseCallRecord = () => setShowCallRecord(false);
    const handleShowCallRecord = () => setShowCallRecord(true);

    const [showCallDetails, setShowCallDetails] = useState(false);
    const handleCloseCallDetails = () => setShowCallDetails(false);
    const handleShowCallDetails = () => setShowCallDetails(true);

    const[HistoryCall, setHistoryCall]=useState([]);
    const [showHistoryCall, setShowHistoryCall] = useState(false);
    const handleCloseHistoryCall = () => setShowHistoryCall(false);
    const handleShowHistoryCall = () =>setShowHistoryCall(true);

    const [ShowHistoryEntryCall, setShowHistoryEntryCall] = useState(false);
    const handleShowShowHistoryEntryCall = () => setShowHistoryEntryCall(true);
    const handleCloseShowHistoryEntryCall = () => setShowHistoryEntryCall(false);

    const selectRowCall={
        mode:'radio',
        onSelect:(row,isSelect,rowIndex)=>{
            setBinCallRecord(row['BIN']);
            setNameCallRecord(row['Name']);
            handleShowCallRecord()
        }
    }
    const getCallData=()=>{

        setDataStatusCall(true);
        setDatalengthCall(0)

        const Commi=document.getElementById("cmbCommiCall");
        const CommiValue=Commi.options[Commi.selectedIndex].text;

        const DivisionCall=document.getElementById("cmbDivisionCall");
        const DivisionValueCall=DivisionCall.options[DivisionCall.selectedIndex].text;

        const CircleCall=document.getElementById("cmbCircleCall");
        const CircleValueCall=CircleCall.options[CircleCall.selectedIndex].text;

        const RangeCall=document.getElementById("cmbRangeCall");
        const RangeCallValue=RangeCall.options[RangeCall.selectedIndex].text;

        const EconomicActivityCall=document.getElementById("cmbEconomicActivityCall");
        const EconomicActivityCallValue=EconomicActivityCall.options[EconomicActivityCall.selectedIndex].text;

        const ItemsCall=document.getElementById("cmbItemsCall");
        const ItemsCallValue=ItemsCall.options[ItemsCall.selectedIndex].text;

        const OfficerCall=document.getElementById("txtOfficerCall").value;

        const cmbCallDate=document.getElementById("cmbCallDate");



        const DataLimitCall=document.getElementById("cmbDataLimitCall");
        const DataLimitValueCall=DataLimitCall.options[DataLimitCall.selectedIndex].text;

        let getCommiCall=" ";
        let getDivisionCall=" ";
        let getCircleCall=" ";
        let getRangeCall=" ";
        let getEconomicActivityCall="" ;
        let getItemsCall="" ;
        let getOfficerCall="" ;
        let getCallDate="" ;
        let getlimitCall ="";

        let jsonObject;



        if(state.accessCom=="NBR")
        {if(Commi.selectedIndex!=0){getCommiCall="And Commissionerate Like '%"+CommiValue+"%'"}}
        else{getCommiCall="And Commissionerate Like '%"+state.accessCom+"%'"}

        if(state.accessDiv=="All Division"){if(DivisionCall.selectedIndex!=0){getDivisionCall="And Division Like '%"+DivisionValueCall+"%'"}}
        else{getDivisionCall="And Division Like '%"+state.accessDiv+"%'"}

        if(state.accessCir=="All Circle"){if(CircleCall.selectedIndex!=0){getCircleCall="And Circle = '"+CircleValueCall+"'"}}
        else {getCircleCall="And Circle = '"+state.accessCir+"'"}

        if(RangeCall.selectedIndex!=0){getRangeCall="And Range_Name ='"+RangeCallValue+"'"}
        if(EconomicActivityCall.selectedIndex!=0){getEconomicActivityCall="And Economic_Activity Like '%"+EconomicActivityCallValue+"%'  "}
        if(ItemsCall.selectedIndex!=0){getItemsCall="And Category= '"+ItemsCallValue+"'"}

        if(OfficerCall!=""){getOfficerCall="And Caller Like '%"+OfficerCall+"%'"}


        if(cmbCallDate.selectedIndex==1){getCallDate=" And Call_Date='"+appUtility.getDate(CallDate)+"' "}
        if(cmbCallDate.selectedIndex==2){getCallDate=" And Call_Date >'"+appUtility.getDate(CallDate)+"' "}
        if(cmbCallDate.selectedIndex==3){getCallDate=" And Call_Date <'"+appUtility.getDate(CallDate)+"' "}



        if(DataLimitCall.selectedIndex !=0){getlimitCall=" LIMIT " +DataLimitValueCall

            jsonObject={"sql":"select Id,Circle,Range_Name,BIN,Name,Economic_Activity,Category,Caller,Call_Date,Comments from Call_Data_view where 1=1 "+getCommiCall+" "+getDivisionCall+" "+getCircleCall+" "+getRangeCall+" "+getEconomicActivityCall+" "+getItemsCall+" "+getOfficerCall+" "+getCallDate+" "+getlimitCall+"  "}



        }else{getlimitCall=""

            jsonObject={"sql":" Select count(Id)AS 'Total ID' from Call_Data   "}



        }

        if(cmbCallDate.selectedIndex !=0){
            if(CallDate==null){cogoToast.error("Please select Date");setDataStatusCall(false);}else {
                setColumnCall([{}]);setDataCall([])
                RestClient.PostRequest(AppUrl.getData, jsonObject).then(async result => {
                    setDatalengthCall(result.length)
                    if (result == "") {
                        cogoToast.error("Data not found");
                        setDataStatusCall(false)
                    } else {
                        await setColumnCall(
                            Object.keys(result[0]).map((k) => {
                                return {dataField: k, text: k, sort: true}
                            })
                        )
                        await setDataCall(result);
                        setDataStatusCall(false)
                    }
                }).catch(error => {
                    setDataStatusCall(false);
                });
            }
        }else {

            setColumnCall([{}]);setDataCall([])
            RestClient.PostRequest(AppUrl.getData, jsonObject).then(async result => {
                setDatalengthCall(result.length)
                if (result == "") {
                    cogoToast.error("Data not found");
                    setDataStatusCall(false)
                } else {
                    await setColumnCall(
                        Object.keys(result[0]).map((k) => {
                            return {dataField: k, text: k, sort: true}
                        })
                    )
                    await setDataCall(result);
                    setDataStatusCall(false)
                }
            }).catch(error => {
                setDataStatusCall(false);
            });
        }
    }


    const getHistory=(status)=>{
        let jsonObject="";
        if(status==0){
            jsonObject={"sql":" SELECT July_24,July_25,August_24,August_25,September_24,September_25,October_24,October_25,November_24,November_25,December_24,December_25,January_25,January_26,February_25,February_26,March_25,March_26,April_25,April_26,May_25,May_26,June_25,June_26" +
                    ",(July_24+August_24+September_24+October_24+November_24+December_24+January_25+February_25+March_25+April_25+May_25+June_25)As Total_Last_Year," +
                    "(July_25+August_25+September_25+October_25+November_25+December_25+January_26+February_26+March_26+April_26+May_26+June_26)As Total_Upto FROM nbr.revenue_25_26_view where BIN='"+BinCallRecord+"' "};

        }else if(status==1){
            jsonObject={"sql":" select FY,Month,round(Closing_balance_vat/Deposited_vat,1)AS Balance_TR,round(Total_Payable_VAT/Deposited_vat,1)AS Payable_TR,`Deposite_%`,`Rebate_%`,`Decreasing_%`,Total_Sales_Value,Total_Payable_Vat,Total_Payable_SD,Total_Input_Tax_Credit_Value,Total_Input_Tax_Credit_VAT,Increasing_Adjustment,Decreasing_Adjustment,Net_Payable_VAT,Net_Payable_SD,Deposited_VAT,Deposited_SD,Closing_Balance_VAT,Closing_Balance_SD,VDS_Increasing,VDS_Decreasing,AT_Paid from Revenue_Analyse_View where BIN='"+BinCallRecord+"' order by Month_Code Desc "};

        }else if(status==2){
            jsonObject={"sql":" SELECT HSCODE,Description As Description_Of_Goods,Supply_Qty,Supply_Unit As Unit,Rm_Price,Addition_Price,Addition_Parcentage AS 'Add_%',Total_Price,Entry_Date As 'Effect_Date',DATEDIFF(CURDATE(),Entry_Date) AS Total_Days,Entry_Date,Status,Sale_Category,Comments As Comments_for_goods FROM `Co_Efficient` where BIN='"+BinCallRecord+"' "};

        }else if(status==3){
            jsonObject={"sql":" SELECT Court,Mamla_No,Mamla_Year,Mamla_Type,Amount,Status from Mamla where BIN='"+BinCallRecord+"' "};

        } else if(status==4){
            jsonObject={"sql":" SELECT Id, Reasons from negative_bin where BIN='"+BinCallRecord+"' "};

        } else if(status==5){
            jsonObject={"sql":" SELECT Caller,Call_Date,Comments from Call_Data where BIN='"+BinCallRecord+"' "};

        }else if(status==6){
            jsonObject={"sql":" SELECT Bill_Year,Bill_Month,Consumption_Unit As Unit,Unit_Price As Price,Entry_Officer,Entry_Date from Electricity_Data where BIN='"+BinCallRecord+"' "};

        }else if(status==7){
            jsonObject={"sql":" SELECT Id, SMS,SMS_Sender,SMS_Date from sms_Data where BIN='"+BinCallRecord+"' "};

        }else if(status==8){
            jsonObject={"sql":" SELECT * FROM debt_report where BIN='"+BinCallRecord+"' "};

        }else if(status==9){
            jsonObject={"sql":" SELECT * FROM BIN where BIN='"+BinCallRecord+"' "};

        }

        setColumnCallRecord([{}]);setDataCallRecord([])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{

            if(result==""){cogoToast.error("Data not found");}else {
                await setColumnCallRecord(
                    Object.keys(result[0]).map((k) => {
                        return {dataField: k, text: k, sort: true}
                    })
                )
                await setDataCallRecord(result);
                handleShowCallDetails()



            }
        }).catch(error=>{ });

    }

    const getHistoryCall=()=>{

        let jsonObject={"sql":" SELECT Id,Detailes FROM bin_detailes where BIN='"+BinCallRecord+"'  "};

        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{

            if(result==""){cogoToast.error("Data not found");}else {
                setHistoryCall(result);
                setShowHistoryCall(true);

            }
        }).catch(error=>{ });

    }
    const saveFlagCall=()=>{
        const FlagYesCall=document.getElementById("cmbFlagYesCall");

        if(FlagYesCall.selectedIndex==0){cogoToast.error("Please Select Flag Criteria")}else {
            RestClient.PostRequest(AppUrl.updateData, {"sql": "Update bin set Flag="+FlagYesCall.selectedIndex+" where Bin='"+BinCallRecord+"' "}).then(result => {
                if (result == 1) {
                    cogoToast.success("Flag saved")

                } else {
                    cogoToast.error("Flag not saved")
                }
            }).catch(error => {
                cogoToast.error(error)
            });
        }



    }
    const updateBinStatusCall=()=>{


        RestClient.PostRequest(AppUrl.updateData, {"sql": "Update bin set BIN_Status='Shut Down' where Bin='"+BinCallRecord+"' "}).then(result => {
            if (result == 1) {
                cogoToast.success("Status has been removed")

            } else {
                cogoToast.error("Status has not been removed")
            }
        }).catch(error => {
            cogoToast.error(error)
        });


    }
    const saveHistoryCall=()=>{

        const historyCall=document.getElementById("txtAreaDetailesCall").value;


           let jsonObject={"sql": "Insert into bin_detailes (Id, BIN,Detailes,Entry_date,Entry_User)Values(NULL, '"+BinCallRecord+"','"+historyCall+"','"+appUtility.getDate(new Date())+"','"+state.name+"') "};

            if(historyCall==""){cogoToast.error("Please insert text")}else{
                RestClient.PostRequest(AppUrl.saveData, jsonObject).then(result => {
                    if (result == 1) {
                        cogoToast.success("Data saved")

                    } else {
                        cogoToast.error("Data not saved")
                    }
                }).catch(error => {
                    cogoToast.error(error)
                });}




    }
    return(
        <Fragment>
            <div >
                <Row className="mt-2">

                    <Col lg={3}>
                        <div className="">
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">NBR</label></Col>
                                <Col lg={9}  xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbCommiCall"
                                            onChange={()=>{
                                                setDivisionCall([]);
                                                setCircleCall([]);
                                                const e = document.getElementById("cmbCommiCall");
                                                const value = e.options[e.selectedIndex].value;
                                                const dt=state.division.filter(x => x.Commissionerate_Id==value);
                                                setDivisionCall(dt)


                                            }}
                                    >
                                        <option >NBR</option>
                                        {
                                            state.commi.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }
                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Division</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbDivisionCall"
                                            onChange={()=>{
                                                setCircleCall([])
                                                const e = document.getElementById("cmbDivisionCall");
                                                const value = e.options[e.selectedIndex].value;
                                                const dt=state.circle.filter(x => x.Division_Id==value);
                                                setCircleCall(dt)


                                            }}
                                    >
                                        <option >All Division</option>

                                        {
                                            DivisionCall.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }
                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Circle</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbCircleCall" >
                                        <option >All Circle</option>

                                        {
                                            CircleCall.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }


                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Range</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbRangeCall"  >
                                        <option >All Range</option>
                                        <option >Range-1</option>
                                        <option >Range-2</option>
                                        <option >Range-3</option>
                                        <option >Range-4</option>
                                        <option >Range-5</option>
                                        <option >Range-6</option>
                                        <option >Range-7</option>
                                        <option >No Range</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Category</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbEconomicActivityCall"  >
                                        <option >All Category</option>
                                        <option >Manufacturing</option>
                                        <option >Services</option>
                                        <option >Other</option>
                                        <option >Imports</option>
                                        <option >Exports</option>
                                        <option >Wholesale</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Items</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbItemsCall"  >
                                        <option value="0">All Items</option>
                                        {
                                            state.category.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }

                                    </select>
                                </Col>

                            </Row>

                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Officer</label></Col>
                                <Col lg={9}xs={8}>
                                    <input type="text" className="w-100" id="txtOfficerCall"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Date</label></Col>
                                <Col lg={4}xs={4}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbCallDate"  >
                                        <option >All</option>
                                        <option >Equal</option>
                                        <option >Greater</option>
                                        <option >Less</option>
                                    </select>
                                </Col>

                                <Col lg={5}xs={8}>
                                    <DatePicker selected={CallDate}
                                                onChange={(date) => setCallDate(date)}
                                                dateFormat='dd-MM-yyyy'
                                                seletable
                                                isClearable
                                                showYearDropdown
                                                scrollableMonthYearDropdown
                                    />
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Data</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbDataLimitCall"  >
                                        <option >All</option>
                                        <option >100</option>
                                        <option >200</option>
                                        <option >500</option>
                                        <option >1000</option>
                                        <option >2000</option>
                                        <option >3000</option>
                                        <option >5000</option>
                                        <option >10000</option>
                                        <option >20000</option>
                                        <option >50000</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-4">
                                <Col lg={3} >

                                </Col>
                                <Col lg={9} >
                                    <button className="w-100 text-danger" onClick={getCallData}>Search</button>
                                </Col>


                            </Row>




                        </div>
                    </Col>

                    <Col lg={9}>

                        <div className="overflow-scroll animated zoomIn purchaseMedium2Div">
                            {
                                DataStatusCall? <LoadingText/>
                                    :<BootstrapTable ref={ref} selectRow={selectRowCall} id="BinTable" keyField='Id' data={DataCall}  columns={ColumnCall}></BootstrapTable>


                            }
                        </div>
                        <di>
                            <label className="text-danger">Data found: {DataLengthCall}</label>

                        </di>

                    </Col>


                </Row>


            </div>

            <Modal show={showCallRecord} onHide={handleCloseCallRecord}>
                <Modal.Header closeButton>
                    <label>{NameCallRecord}</label>
                </Modal.Header>
                <Modal.Body>

                    <div className="w-75">
                        <Button className="" variant="danger" onClick={()=>getHistory(0)} >Revenue Monthly</Button> <label>__</label>
                        <Button className="" variant="primary" onClick={()=>getHistory(1)} >Revenue Analysis</Button>
                    </div><hr className="mb-1"/>
                    <div className="w-75">

                        <Button className="" variant="danger" onClick={()=>getHistory(4)} >Negative history</Button> <label>____</label>
                        <Button className="" variant="primary" onClick={()=>getHistory(2)} >4.3</Button>
                    </div><hr className="mb-1"/>

                    <div className="w-75">
                        <Button className="" variant="danger" onClick={()=>getHistory(3)} >Mamla History</Button><label>_______</label>
                        <Button className="" variant="primary" onClick={()=>getHistory(8)} >Debt History</Button>
                    </div><hr className="mb-1"/>





                <div className="w-75">
                    <Button variant="primary" onClick={()=>getHistory(6)}>Electricity History</Button><label>____</label>
                    <Button variant="primary" onClick={getHistoryCall}>History</Button>

                </div>

            </Modal.Body>
            <Modal.Footer>


                <Button variant="danger" onClick={()=>getHistory(9)}>Basic Info</Button>
                <Button variant="primary" onClick={()=>getHistory(5)}>Call Log</Button>
                <Button  variant="primary" onClick={()=>getHistory(7)}>SMS Log</Button>
                <Button  variant="primary" onClick={handleShowShowHistoryEntryCall}>Entry History</Button>

                <Button variant="danger" onClick={handleCloseCallRecord}>
                    Close
                </Button>

            </Modal.Footer>
            </Modal>
            <Modal show={showCallDetails} onHide={handleCloseCallDetails} dialogClassName="custom-modal-width">
                <Modal.Header closeButton>

                    <label>{NameCallRecord}</label>

                </Modal.Header>
                <Modal.Body className="scrollable-x">
                    <div className="wide-content">
                        {<BootstrapTable  keyField='Id'  data={DataCallRecord} columns={ColumnCallRecord}></BootstrapTable>}
                    </div>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseCallDetails}>
                        Close
                    </Button>


                </Modal.Footer>
            </Modal>

            <Modal show={showHistoryCall} onHide={handleCloseHistoryCall}>
                <Modal.Header closeButton>

                    <label>Detailes History</label>

                </Modal.Header>
                <Modal.Body>
                    {
                        HistoryCall.map((ctr,index)=>{
                            return (
                                <div> <label>{ctr.Detailes}</label>
                                    <hr/>
                                </div>
                            )
                        })
                    }

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseHistoryCall}>
                        Close
                    </Button>


                </Modal.Footer>
            </Modal>
            <Modal show={ShowHistoryEntryCall} onHide={handleCloseShowHistoryEntryCall}>
                <Modal.Header closeButton>

                    <label>History entry form</label>

                </Modal.Header>
                <Modal.Body>
                    <textarea className="text-area" id="txtAreaDetailesCall"></textarea>
                    <hr/>
                    <Button variant="success" onClick={saveFlagCall} >
                        Flag ? Yes
                    </Button>
                    <select id="cmbFlagYesCall">
                        <option>Select</option>
                        <option>Low</option>
                        <option>High</option>
                        <option>Medium</option>
                        <option>Highest</option>
                    </select>
                    <hr/>



                </Modal.Body>
                <Modal.Footer>

                    <Button variant="primary" onClick={updateBinStatusCall}>
                        Shut Down
                    </Button>
                    <Button variant="danger" onClick={saveHistoryCall} >
                        Save History
                    </Button>
                </Modal.Footer>
            </Modal>
        </Fragment>

    )
}
